import { nzApiAxios } from 'src/utils/nz-axios/nz-axios';

export const pagesApiUrl = '/CustomPage';

const GetPageBySlug = (slug: string | undefined) =>
  nzApiAxios.get(pagesApiUrl + `/${slug}`).then((response) => response.data);

const GetMenuPages = () => nzApiAxios.get(pagesApiUrl + `/pages`).then((response) => response.data);

const API = {
  getPageBySlug: GetPageBySlug,
  getMenuPages: GetMenuPages
};

export default API;
